(() => {
  document.addEventListener("DOMContentLoaded", () => {
    if (!lightbox) {
      return;
    }

    lightbox.option({
      alwaysShowNavOnTouchDevices: true,
      resizeDuration: 400,
      fadeDuration: 400,
      albumLabel: "%1 de %2",
      wrapAround: true,
      disableScrolling: true,
      positionFromTop: 104,
    });
  });
})();
